import React,{useEffect,useState,useRef} from 'react'

function useOnScreen(ref) {

  const [isIntersecting, setIntersecting] = useState(false)

  const observer = new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting)
  )

  useEffect(() => {
    observer.observe(ref.current)
    return () => { observer.disconnect() }
  })

  return isIntersecting
}


function Features() {
  const title = useRef()
  const isVisible = useOnScreen(title)
  if(isVisible) title.current.classList.add('enter-left')
  
  const feed = useRef()
  const isVisible2 = useOnScreen(feed)
  if(isVisible2) feed.current.classList.add('enter-right')

  const calendar = useRef()
  const isVisible3 = useOnScreen(calendar)
  if(isVisible3) calendar.current.classList.add('enter-left')

  const lms = useRef()
  const isVisible4 = useOnScreen(lms)
  if(isVisible4) lms.current.classList.add('enter-right')

  const notification = useRef()
  const isVisible5 = useOnScreen(notification)
  if(isVisible5) notification.current.classList.add('enter-left')

  const wifi = useRef()
  const isVisible6 = useOnScreen(wifi)
  if(isVisible6) wifi.current.classList.add('enter-right')

  return (



    <div id='features' className='w-full sm:p-6 p-2 flex flex-col items-center min-h-screen z-10 bg-darkblue'>
      <h1 ref={title} className='text-center md:text-6xl text-[8vw] md:p-6 md:m-6 p-[2vw] m-[2vw] font-bold text-white'>Why AutoJoomer?</h1>
      <div className='max-w-6xl md:gap-10 gap-[4vw] sm:m-6 m-2 flex flex-col items-center justify-center'>

        <div ref={wifi} className='flex max-w-3xl bg-white items-center rounded-2xl'>
        <img src = {require('../assets/wifi.png')} className='md:w-[40%] w-[50%] p-6' alt=''/>
        <h1 className='text-xl  sm:text-3xl md:p-6 p-3'>Auto login to college <span className='text-blue' >wifi.</span></h1>
        </div>
      
        <div ref={feed} className='flex max-w-3xl bg-white items-center rounded-2xl'>
        <h1 className='text-xl  sm:text-3xl p-3 md:p-6'>Get to know the latest updates from the <span className='text-blue'>feed</span>.</h1>
          <img src = {require('../assets/Feed.png')} className='md:w-[40%] w-[50%] p-6' alt=''/>
        </div>

        <div ref={calendar} className='flex max-w-3xl bg-white items-center rounded-2xl'>
        <img src = {require('../assets/Calender.png')} className='md:w-[40%] w-[50%] p-6' alt=''/>
        <h1 className='sm:text-3xl  text-xl md:p-6 p-3'>Keep track of your assignments using our <span className='text-blue'>calendar</span>.</h1>
        </div>

        <div ref={lms} className='flex max-w-3xl bg-white items-center rounded-2xl'>
        <h1 className='sm:text-3xl  text-xl md:p-6 p-3'>Access the LMS using the <span className='text-blue' >webview.</span></h1>
          <img src = {require('../assets/LMS.png')} className='md:w-[40%] w-[50%] p-6' alt=''/>
        </div>

        <div ref={notification} className='flex max-w-3xl bg-white items-center rounded-2xl'>
          <img src = {require('../assets/Notifications.png')} className='md:w-[40%] w-[50%] p-6' alt=''/>
          <h1 className='sm:text-3xl  text-xl md:p-6 p-3'>Get <span className='text-blue'>notifications</span> when your assignments are due.</h1>
          
        </div>
      </div>
    </div>
  )
}

export default Features